<div
  class="slider-container"
  [attr.data-disabled]="isDisabled()"
  [attr.data-range]="range()"
>
  <div class="slider-header">
    @if (label()) {
      <label class="slider-label" [attr.for]="id">
        {{ label() }}
      </label>
    }

    <!-- Value display -->
    @if (showValue()) {
      <div class="slider-value">
        @if (!range()) {
          <span>{{ value() }}</span>
        } @else {
          <span>{{ rangeStart() }} - {{ rangeEnd() }}</span>
        }
      </div>
    }
  </div>

  @if (!range()) {
    <!-- Single Value Slider -->
    <div class="slider-wrapper">
      <div class="slider-rail">
        <div class="slider-track">
          <!-- Filled track -->
          <div class="slider-track-fill" [style.width.%]="percentage()"></div>
        </div>

        <div
          class="slider-marker"
          [style.left.%]="percentage()"
          (mousedown)="onMarkerMouseDown($event, 'value')"
        >
          <umss-marker [tooltip]="value() + ''"></umss-marker>
        </div>

        @for (mark of marks(); track mark.value) {
          <div
            class="slider-mark"
            [style.left.%]="getMarkPercentage(mark.value)"
          >
            <span class="slider-mark-dot"></span>
            <span class="slider-mark-connector"></span>
            <span class="slider-mark-label pg-mini-medium">{{
              mark.label
            }}</span>
          </div>
        }
      </div>

      <!-- Hidden native input -->
      <input
        type="range"
        [id]="id"
        class="slider-input"
        [min]="min()"
        [max]="max()"
        [step]="step()"
        [value]="value()"
        [disabled]="isDisabled()"
        (input)="onSliderChange($event)"
        [attr.aria-label]="label() || 'Slider'"
        [attr.aria-valuemin]="min()"
        [attr.aria-valuemax]="max()"
        [attr.aria-valuenow]="value()"
      />
    </div>
  } @else {
    <!-- Range Slider -->
    <div class="slider-wrapper slider-wrapper-range">
      <div class="slider-rail">
        <div class="slider-track">
          <!-- Filled track (between start and end) -->
          <div
            class="slider-track-fill"
            [style.left.%]="rangeStartPercentage()"
            [style.width.%]="rangeEndPercentage() - rangeStartPercentage()"
          ></div>
        </div>

        <!-- Custom markers -->
        <div
          class="slider-marker slider-marker-start"
          [umssTooltip]="rangeStart() + ''"
          [style.left.%]="rangeStartPercentage()"
          (mousedown)="onMarkerMouseDown($event, 'start')"
        >
          <umss-marker></umss-marker>
        </div>
        <div
          class="slider-marker slider-marker-end"
          [umssTooltip]="rangeEnd() + ''"
          [style.left.%]="rangeEndPercentage()"
          (mousedown)="onMarkerMouseDown($event, 'end')"
        >
          <umss-marker></umss-marker>
        </div>

        @for (mark of marks(); track mark.value) {
          <div
            class="slider-mark"
            [style.left.%]="getMarkPercentage(mark.value)"
          >
            <span class="slider-mark-dot"></span>
            <span class="slider-mark-connector"></span>
            <span class="slider-mark-label pg-mini-medium">{{
              mark.label
            }}</span>
          </div>
        }
      </div>

      <!-- Single range input - determines which handle to move based on proximity -->
      <input
        type="range"
        [id]="id"
        class="slider-input slider-input-range"
        [min]="min()"
        [max]="max()"
        [step]="step()"
        [value]="rangeStart()"
        [disabled]="isDisabled()"
        (input)="onRangeInputChange($event)"
        (mousedown)="onRangeInputMouseDown()"
        (mouseup)="onRangeInputMouseUp()"
        (touchend)="onRangeInputMouseUp()"
        [attr.aria-label]="label() || 'Range slider'"
        [attr.aria-valuemin]="min()"
        [attr.aria-valuemax]="max()"
        [attr.aria-valuenow]="rangeStart() + ' to ' + rangeEnd()"
      />
    </div>
  }
</div>
